export enum LoginType {
  MYBELL = 'MYBELL',
  ADFS = 'ADFS',
  OFFLINE = 'OFFLINE'
}
